import axios from 'axios';
import { BriefingResourceDetail } from '@/shared/model/briefing-widget.model';
import { handleQueryIncludeArray } from '@/util/ds-util';
import { param } from 'jquery';

const baseBriefingAPI = '/api/briefing';
const makeAThonAPI = '/api/makeAThon';
const apiCompanyBriefingPage = '/company';

export default class BriefingService {
  constructor() {}

  public getBriefingNow(bpId: string, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + `/myBriefing/getBriefingNow`, { params: { bpId, userKey } })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getReportDetail(parentDocId: string, requestId: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/report-detail-get/${parentDocId}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllBriefingPageEnable() {
    return axios.get(baseBriefingAPI + '/myBriefing/getAllBriefingPageEnable');
  }

  public getAllActiveBriefingOrScrap(featureIdx = 7 | 3) {
    // 7 is active briefing, 3 is active scrap
    return axios.get(baseBriefingAPI + '/myBriefing/getAllActiveBriefingOrScrap/' + featureIdx);
  }

  public getAllBriefingPage(
    userKey: string,
    loadCardThumbnails?: boolean,
    bpId?: string,
    page?: number,
    pageSize?: number,
    language?: string,
    keyword?: string,
    requestId?: string,
    mediaType?: string[],
    searchType?: string,
    getIsPinned?: boolean
  ) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/myBriefing/getAllBriefingPage?userKey=' + userKey, {
          params: {
            loadCardThumbnails: loadCardThumbnails || false,
            bpId: bpId || null,
            page: page || 0,
            pageSize: pageSize || null,
            language: language || null,
            keyword: keyword || null,
            requestId: requestId || null,
            mediaType: mediaType || null,
            searchType: searchType || null,
            getIsPinned: getIsPinned || false,
          },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllBriefingPageWithoutCard(userKey: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/myBriefing/getAllBriefingPage?userKey=' + userKey + '&loadCardThumbnails=false')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllReportForBriefingFilter(
    userKey: string,
    bpIds: any,
    documentType?: string[],
    contentType?: string[],
    briefingType?: string[],
    startDate?: string | Date,
    endDate?: string | Date,
    language?: string[],
    page?: number,
    size?: number
  ) {
    const request = {
      userKey: userKey,
      userKeyCheckBookMark: null,
      language: language,
      bpId: null,
      bpIds: bpIds,
      documentType: documentType,
      briefingType: briefingType,
      briefingPrivacy: null,
      contentType: contentType,
      startDate: startDate,
      endDate: endDate,
    };
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/myBriefing/getAllBriefingData', request, { params: { page, size } })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllInsightReportList(
    userKey: string,
    bpId: string,
    startDate?: string | Date,
    endDate?: string | Date,
    userKeyCheckBookmark?: string,
    documentType?: string[],
    contentType?: string[],
    briefingType?: string[],
    language?: string[],
    loadMoreDiscovery = true,
    loadMoreReport = true,
    page?: number,
    size?: number
  ) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(
          baseBriefingAPI + apiCompanyBriefingPage + '/getAllBriefingData',
          {
            userKey: userKey,
            bpId,
            startDate,
            endDate,
            userKeyCheckBookMark: userKeyCheckBookmark,
            documentType,
            contentType,
            briefingType,
            language,
            loadMoreDiscovery,
            loadMoreReport,
          },
          { params: { page, size } }
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public updateUserActivityInformation(
    requestId: string,
    userKey: string,
    briefingPageId?: string,
    parentDocId?: string,
    isLiked?: boolean,
    isViewed?: boolean,
    isShared?: boolean,
    isDislike?: boolean
  ) {
    const request = {
      requestId: requestId,
      userKey: userKey,
      briefingPageId: briefingPageId,
      parentDocId: parentDocId,
      isLiked: isLiked,
      isViewed: isViewed,
      isShared: isShared,
      isDislike: isDislike,
    };
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/updateUserActivityInformation', request)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callApiGetBriefingPageRecommendationList() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/myBriefing/getAllRecommendationEnable')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public createNewBriefing(
    requestId,
    userKey,
    language,
    bpResourceList,
    conversationId?,
    title?,
    description?,
    privacy?,
    reportTypes?: string[],
    chatSetting?: any,
    createAgentTypes?: any,
    connectScrapAgentList?: any,
    listMessageIdsFocus?: any,
    promptReportFocus?: any,
    reportPrivacy?: any
  ) {
    const requestBody = {
      requestId: requestId,
      userKey: userKey,
      language: language,
      // bpResourceList: bpResourceList,
      conversationId: conversationId,
    };
    if (title) {
      requestBody['briefingTitle'] = title;
    }
    if (description) {
      requestBody['briefingDescription'] = description;
    }
    if (privacy) {
      requestBody['briefingPrivacy'] = privacy;
    }
    if (reportTypes) {
      requestBody['reportTypes'] = reportTypes;
    }
    if (chatSetting) {
      requestBody['chatSetting'] = chatSetting;
    }
    if (createAgentTypes) {
      requestBody['createAgentTypes'] = createAgentTypes;
    }
    if (connectScrapAgentList) {
      requestBody['connectScrapAgentList'] = connectScrapAgentList;
    }
    if (listMessageIdsFocus) {
      requestBody['listMessageIdsFocus'] = listMessageIdsFocus;
    }
    if (promptReportFocus) {
      requestBody['promptReportFocus'] = promptReportFocus;
    }
    if (reportPrivacy) {
      requestBody['reportPrivacy'] = reportPrivacy;
    }

    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/myBriefing/createBriefingPage', requestBody)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getPeopleWithQuote(bpId: string, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + `/myBriefing/getPeopleWithQuote`, { params: { bpId, userKey } })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getInsightReport(bpId: string, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + `/myBriefing/getInsightReport`, { params: { bpId, userKey } })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getSns(bpId: string, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + `/myBriefing/getSocialMedia`, { params: { bpId, userKey } })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getCompanyRelate(bpId: string, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + `/myBriefing/getRelateCompany`, { params: { bpId, userKey } })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getPeopleRelate(bpId: string, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + `/myBriefing/getRelatePeople`, { params: { bpId, userKey } })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getTodayReport(documentType: string[], sessionId: string, language: string[]) {
    if (!documentType) return;
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + `/home/getAllTodayReport`, {
          params: {
            documentType,
            language,
            sessionId,
          },
          paramsSerializer: query => handleQueryIncludeArray(query),
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getHomeBriefingData(
    documentType?: string[],
    contentType?: string[],
    startDate?: string | Date,
    endDate?: string | Date,
    language?: string[],
    loadMoreDiscovery = true,
    loadMoreReport = true,
    page?: number,
    size?: number,
    sessionId?: string,
    bpId?: string
  ) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(
          baseBriefingAPI + '/home/getAllBriefingData',
          {
            documentType,
            contentType,
            language,
            startDate,
            endDate,
            loadMoreDiscovery,
            loadMoreReport,
            sessionId,
            bpId,
          },
          {
            params: { page, size },
          }
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllMyBriefingData(
    bpId: string,
    documentType?: string[],
    contentType?: string[],
    briefingType?: string[],
    // dateText?: string,
    startDate?: string | Date,
    endDate?: string | Date,
    language?: string[],
    loadMoreDiscovery = true,
    loadMoreReport = true,
    page?: number,
    size?: number,
    sessionId?: string,
    mediaType?: string[],
    collectedQualities?: number[]
  ) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(
          baseBriefingAPI + '/myBriefing/getAllBriefingData',
          {
            bpId,
            documentType,
            contentType,
            briefingType,
            // dateText,
            startDate,
            endDate,
            language,
            loadMoreDiscovery,
            loadMoreReport,
            sessionId,
            mediaType,
            collectedQualities,
          },
          {
            params: { page, size },
          }
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllCompanyBriefingData(
    userKeyCheckBookmark: string,
    bpId: string,
    documentType?: string[],
    contentType?: string[],
    briefingType?: string[],
    // dateText?: string,
    startDate?: string | Date,
    endDate?: string | Date,
    language?: string,
    loadMoreDiscovery = true,
    loadMoreReport = true,
    page?: number,
    size?: number,
    sessionId?: string
  ) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(
          baseBriefingAPI + apiCompanyBriefingPage + '/getAllBriefingData',
          {
            userKeyCheckBookMark: userKeyCheckBookmark,
            bpId,
            documentType,
            contentType,
            briefingType,
            // dateText,
            startDate,
            endDate,
            language,
            loadMoreDiscovery,
            loadMoreReport,
            sessionId,
          },
          {
            params: { page, size },
          }
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllSocialBriefingData(
    bpId: string,
    documentType?: string[],
    contentType?: string[],
    briefingType?: string[],
    briefingPrivacy?: string[],
    // dateText?: string,
    startDate?: string | Date,
    endDate?: string | Date,
    language?: string,
    loadMoreDiscovery = true,
    loadMoreReport = true,
    page?: number,
    size?: number,
    userKey?: string,
    userKeyCheckBookMark?: string,
    sessionId?: string,
    mediaType?: string[]
  ) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(
          baseBriefingAPI + '/socialBriefing/getAllBriefingData',
          {
            bpId,
            documentType,
            contentType,
            briefingType,
            briefingPrivacy,
            // dateText,
            startDate,
            endDate,
            language,
            loadMoreDiscovery,
            loadMoreReport,
            userKey,
            userKeyCheckBookMark,
            sessionId,
            mediaType,
          },
          {
            params: { page, size },
          }
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllBriefingDataForMycreate(
    bpId: string,
    documentType?: string[],
    contentType?: string[],
    briefingType?: string[],
    briefingPrivacy?: string[],
    // dateText?: string,
    startDate?: string | Date,
    endDate?: string | Date,
    language?: string[],
    loadMoreDiscovery = true,
    loadMoreReport = true,
    page?: number,
    size?: number,
    userKey?: string,
    userKeyCheckBookMark?: string,
    sessionId?: string,
    mediaType?: string[],
    keywords?: string
  ) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(
          baseBriefingAPI + '/myCreate/getAllBriefingData',
          {
            bpId,
            documentType,
            contentType,
            briefingType,
            briefingPrivacy,
            // dateText,
            startDate,
            endDate,
            language,
            loadMoreDiscovery,
            loadMoreReport,
            userKey,
            userKeyCheckBookMark,
            sessionId,
            mediaType,
            keywords,
          },
          {
            params: { page, size },
          }
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getMyReport(
    requestId: string,
    userKey?: string,
    mediaType?: string[],
    startDate?: string | Date,
    endDate?: string | Date,
    service_language?: string,
    keyword?: string,
    page?: number,
    pageSize?: number
  ) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/search/search-my-report', {
          params: {
            requestId,
            userKey,
            mediaType,
            startDate,
            endDate,
            service_language,
            keyword,
            page,
            pageSize,
          },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllResourceData(
    documentType?: string[],
    startDate?: string | Date,
    endDate?: string | Date,
    loadMoreDiscovery = true,
    loadMoreReport = true,
    page?: number,
    size = 10
  ) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(
          baseBriefingAPI + '/resource/getAllResourceData',
          {
            documentType,
            startDate,
            endDate,
            loadMoreDiscovery,
            loadMoreReport,
          },
          {
            params: { page, size },
          }
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public feedUpdateStatus(payload: {
    id: string;
    briefingPageId: string;
    parentDocId: string;
    isLiked?: boolean;
    isBookmarked?: boolean;
    isDeleted?: boolean;
    typeDocument: string;
  }) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/feedUpdateStatus', payload)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callAPIHideCardInHome(payload: {
    id?: string;
    similar_hash?: string;
    userKey?: string;
    briefingPageId?: string;
    parentDocId?: string;
    isLiked?: boolean;
    isBookmarked?: boolean;
    isDeleted?: boolean;
    typeDocument?: string;
  }) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/hideCardInHome', payload)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public saveBriefingResource(
    documents: any[],
    isUpdate?: boolean,
    saveType?: string,
    reportTypes?: string[],
    reportId?: string,
    privateType?: string
  ) {
    return new Promise<any>((resolve, reject) => {
      if (isUpdate === undefined || isUpdate === null || (isUpdate !== undefined && isUpdate === false)) {
        isUpdate = false;
      } else if (isUpdate !== undefined && isUpdate === true) {
        isUpdate = true;
      }

      let tempUrl = baseBriefingAPI + '/briefingResource/saveBriefingResource?isUpdate=' + isUpdate;

      if (saveType && saveType.trim().length > 0) {
        tempUrl = tempUrl.concat('&saveType=' + saveType);
      }

      if (reportTypes && reportTypes.length > 0) {
        tempUrl = tempUrl.concat('&reportTypes=' + reportTypes);
      }

      if (privateType && privateType.length > 0) {
        tempUrl = tempUrl.concat('&privateType=' + privateType);
      }

      if (reportId && reportId?.length > 0) {
        tempUrl = tempUrl.concat('&reportId=' + reportId);
      }

      axios
        .post(tempUrl, documents)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public updateTypeBriefingPage(bpId: string, bpType: 'BRIEFING_PAGE' | 'RECOMMENDATION_BRIEFING', userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/myBriefing/updateTypeBriefingPage', null, { params: { bpId, bpType, userKey } })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callApiGetAllMyResources(userKey: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/myBriefing/getAllMyResources?userKey=' + userKey)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getDiscovery(bpId: string, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + `/myBriefing/getDiscovery`, { params: { bpId, userKey } })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllBriefingResourcesEnable(bpId: string, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/myBriefing/getAllBriefingResourcesEnable', { params: { bpId, userKey } })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getSubscribeBriefingPage(
    bpId?: string,
    type?: string,
    subscribeStatus?: string,
    page?: number,
    size?: number,
    keyword?: string,
    requestId?: string
  ) {
    const payload = {
      bpId,
      type,
      subscribeStatus,
      page,
      size,
      requestId,
    };
    if (keyword) {
      payload['keyword'] = keyword;
    }
    if (requestId) {
      payload['requestId'] = requestId;
    }
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/socialBriefing/getSubscribeBriefingPage', {
          params: payload,
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getSubscribeCompanyAgent(bpId?: string, type?: string, subscribeStatus?: string, page?: number, size?: number) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/socialBriefing/getSubscribeCompanyAgent', {
          params: {
            bpId,
            type,
            subscribeStatus,
            page,
            size,
          },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getBriefingInfo(bpId?: string, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/socialBriefing/getBriefingInfo', {
          params: { bpId, userKey },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public updateSubscribeBriefingPage(bpId: string, status: 'UN_SUBSCRIBE' | 'SUBSCRIBE', userKey?: string) {
    const payload = { bpId, status, userKey };
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/socialBriefing/updateSubscribeBriefingPage', payload)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getBriefingPageOtherUser(agentKey: string, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/socialBriefing/getBriefingPageOtherUser', { params: { agentKey, userKey } })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getAllFeaturedBriefings(userKey?: string, language?: string[]) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/socialBriefing/getAllFeaturedBriefings', { userKey, language })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public saveUserResource(
    requestId: number | string,
    originType: 'REPORT' | 'DISCOVERY' | string,
    parentDocDetail: BriefingResourceDetail,
    userKey?: string
  ) {
    const payload = { ...parentDocDetail, doc_type: 3 } as BriefingResourceDetail;
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/briefingResource/saveUserResource', {
          requestId,
          originType,
          parentDocDetail: payload,
          userKey,
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public unSaveUserResource(requestId: any, parentDocId: string, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(
          baseBriefingAPI + '/briefingResource/unSaveUserResource',
          {},
          {
            params: {
              requestId,
              parentDocId,
              userKey,
            },
          }
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public removeResourceDocument(bpId: string, resourceId: string[], userKey?: string) {
    const requestBody = {
      bpId,
      resourceId,
      userKey,
    };

    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/briefingResource/removeResouceDocument', requestBody)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public searchAll(requestId: string, keyword: string, serviceLanguage: string, page?: number, size?: number, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/search/searchAll', {
          params: {
            requestId,
            keyword,
            serviceLanguage,
            page,
            size,
            userKey,
          },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public searchBriefing(requestId: string, keyword: string, serviceLanguage: string, page?: number, size?: number, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/search/searchBriefing', {
          params: {
            requestId,
            keyword,
            serviceLanguage,
            page,
            size,
            userKey,
          },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public searchDiscovery(requestId: string, keyword: string, serviceLanguage: string, page?: number, size?: number, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/search/searchDiscovery', {
          params: {
            requestId,
            keyword,
            serviceLanguage,
            page,
            size,
            userKey,
          },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public searchReport(requestId: string, keyword: string, serviceLanguage: string, page?: number, size?: number, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/search/searchReport', {
          params: {
            requestId,
            keyword,
            serviceLanguage,
            page,
            size,
            userKey,
          },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public searchPeopleCompany(requestId: string, keyword: string, serviceLanguage: string, page?: number, size?: number, userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/search/searchPeopleCompany', {
          params: {
            requestId,
            keyword,
            serviceLanguage,
            page,
            size,
            userKey,
          },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public updatePinBriefing(bpId, isPin, userKey, bpType) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + `/briefingResource/updatePin?isPin=${isPin}&bpId=${bpId}&userKey=${userKey}&bpType=${bpType}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callAPIDeleteListBriefingPage(userKey: string, briefingIds: any[]) {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(baseBriefingAPI + '/briefingPage/deleteListBriefingPage?userKey=' + userKey + '&bpIds=' + briefingIds)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callAPIUpdateBriefingPage(
    requestId: string,
    userKey: string,
    bpId: string,
    briefingTitle: string,
    briefingDescription: string,
    briefingPrivacy: string,
    reportTypes: string[],
    chatSetting?: any,
    promptReportFocus?: string
  ) {
    const requestBody = {
      requestId,
      userKey,
      bpId,
      briefingTitle,
      briefingDescription,
      briefingPrivacy,
      reportTypes,
      chatSetting,
      promptReportFocus,
    };

    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/myBriefing/updateBriefingPage', requestBody)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public searchMyBriefing(
    requestId: string,
    userKey: string,
    keyword: string,
    serviceLanguage?: string[],
    searchType?: string,
    startDate?: string,
    endDate?: string,
    page?: number,
    pageSize?: number
  ): Promise<any> {
    return axios.get('api/briefing/search/search-my-briefing', {
      params: {
        requestId,
        userKey,
        keyword,
        service_language: serviceLanguage,
        searchType,
        startDate,
        endDate,
        page,
        pageSize,
      },
    });
  }

  public callApiGenerateTitleAndSummary(conversation: any[], language: string, resources: any[]) {
    const requestBody = {
      conversation: conversation,
      language: language,
      resources: resources,
    };

    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/briefingPage/generateTitleAndSummary', requestBody)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callApiCheckBriefingPageScope(userKey: string, bpId: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/checkBriefingPageScope?userKey=' + userKey + '&bpId=' + bpId)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public triggerOpenBriefingPage(bpId: string, bpType: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/briefingPage/openBriefingPage?bpId=' + bpId + '&bpType=' + bpType)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public checkIframeAllowed(urlInput: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/checkIframeAllowed?urlInput=' + urlInput)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public accessHome() {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/home/accessHome')
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callApiGetWidgetEnableByTypeAndBpId(
    userKey: string,
    bpId: string,
    types: string[],
    page?: number,
    language?: string,
    size?: number
  ) {
    const tempUrl = baseBriefingAPI + '/getWidgetEnableByTypeAndBpId?userKey=' + userKey + '&bpId=' + bpId + '&types=' + types;

    if (page && page > -1) {
      tempUrl.concat('&page=' + page);
    }

    if (language && language.replace(' ', '') !== '') {
      tempUrl.concat('&language=' + language);
    }

    if (size && size > 0) {
      tempUrl.concat('&size=' + size);
    }

    return new Promise<any>((resolve, reject) => {
      axios
        .get(tempUrl)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  getAllCompanyBriefingPage(
    userKey: string,
    bpId?: string,
    page?: number,
    size?: number,
    loadCardThumbnails?: boolean,
    language?: string,
    keyword?: string
  ) {
    let params = bpId !== undefined ? `?userKey=${userKey}&bpId=${bpId}` : `?userKey=${userKey}`;

    if (page) {
      params += `&page=${page}`;
    }
    if (size) {
      params += `&size=${size}`;
    }
    if (loadCardThumbnails) {
      params += `&loadCardThumbnails=${loadCardThumbnails}`;
    }
    if (language) {
      params += `&language=${language}`;
    }
    if (keyword) {
      params += `&keyword=${keyword}`;
    }

    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/company/getAll' + params)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callApiGetAllCommentByBpId(bpId: string, page?: number, size?: number) {
    const tempUrl = baseBriefingAPI + '/getAllCommentByBpId?bpId=' + bpId;

    if (page && page > -1) {
      tempUrl.concat('&page=' + page);
    }

    if (size && size > 0) {
      tempUrl.concat('&size=' + size);
    }

    return new Promise<any>((resolve, reject) => {
      axios
        .get(tempUrl)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callApiCreateComment(bpId: string, userId: string, comment: string) {
    const tempUrl = baseBriefingAPI + '/create';
    const requestBody = {
      bpId: bpId,
      userId: userId,
      comment: comment,
    };
    return new Promise<any>((resolve, reject) => {
      axios
        .post(tempUrl, requestBody)
        .then(res => resolve(res))
        .catch(err => {
          reject(err);
          console.log(err);
        });
    });
  }

  public callApiCheckCrawDataProcess(ids: string[]) {
    const requestBody = {
      _ids: ids,
    };

    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/goCache/getExistedDocumentByIds', requestBody)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public submitReport(payload: any) {
    const requestBody = {
      userId: payload.userId,
      userName: payload.userName,
      reportId: payload.reportId,
      reportTitle: payload.reportTitle,
    };
    return new Promise<any>((resolve, reject) => {
      axios
        .post(makeAThonAPI + '/report/submit', requestBody)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callAPIBpGenerationStartMessage(requestId: string, bpId: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/bpGenerationStartMessage?requestId=' + requestId + '&bpId=' + bpId)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callAPIGetListContentDetailByIds(parentDocIds: string[], requestId: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/getListContentDetailByIds?parentDocIds=' + parentDocIds + '&requestId=' + requestId)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getCountScrapeData(userKey?: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/briefingPage/countScrapeData', {
          userKey,
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callAPIGetScrapAgents(
    userKey: string,
    bpId?: string,
    page?: number,
    pageSize?: number,
    loadCardThumbnails?: boolean,
    language?: string[],
    keyword?: string
  ) {
    const payload = {
      userKey,
      bpId,
      page,
      pageSize,
      loadCardThumbnails,
    };
    if (language) {
      payload['language'] = language;
    }
    if (keyword) {
      payload['keyword'] = keyword;
    }
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/getListScrapByUserId', {
          params: payload,
          paramsSerializer: query => handleQueryIncludeArray(query),
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public callAPIGetDefaultBpIdScrapAgent(
    userKey: string,
    bpId?: string,
    page?: number,
    pageSize?: number,
    loadCardThumbnails?: boolean,
    language?: string[]
  ) {
    const payload = {
      userKey,
      bpId,
      page,
      pageSize,
      loadCardThumbnails,
    };
    if (language) {
      payload['language'] = language;
    }
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/getDefaultBpIdScrapAgent', {
          params: payload,
          paramsSerializer: query => handleQueryIncludeArray(query),
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getTodaySummaryHome(sessionId = '') {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/getTodayTopicSummary?sessionId=' + sessionId)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public activeBriefingPage(bpId: string, userKey: string, isActive: number, role: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + `/activeBriefingAgent?bpId=${bpId}&userKey=${userKey}&isActive=${isActive}&role=${role}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public getDailyWeeklyThumbnail(userKey: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + `/getDailyWeeklyThumbnail?userKey=${userKey}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public saveBriefingResourceWithBody(
    documentInfos: any,
    isUpdate: any,
    reportId: any,
    saveType: any,
    reportTypes: any,
    privateType: any,
    reportPrivacy: any,
    messages: any,
    promptReportFocus: any,
    createAgentTypes: any,
    podcast: any
  ) {
    const requestBody = {
      documentInfos: null,
      isUpdate: false,
      reportId: null,
      saveType: null,
      reportTypes: null,
      privateType: null,
      reportPrivacy: null,
      messages: null,
      promptReportFocus: null,
      createAgentTypes: null,
      podcast: null,
    };

    if (documentInfos !== undefined && documentInfos !== null) {
      requestBody.documentInfos = documentInfos;
    }

    if (isUpdate !== undefined && isUpdate !== null) {
      requestBody.isUpdate = isUpdate;
    }

    if (reportId !== undefined && reportId !== null) {
      requestBody.reportId = reportId;
    }

    if (saveType !== undefined && saveType !== null) {
      requestBody.saveType = saveType;
    }

    if (reportTypes !== undefined && reportTypes !== null) {
      requestBody.reportTypes = reportTypes;
    }

    if (privateType !== undefined && privateType !== null) {
      requestBody.privateType = privateType;
    }

    if (reportPrivacy !== undefined && reportPrivacy !== null) {
      requestBody.reportPrivacy = reportPrivacy;
    }

    if (messages !== undefined && messages !== null) {
      requestBody.messages = messages;
    }

    if (promptReportFocus !== undefined && promptReportFocus !== null) {
      requestBody.promptReportFocus = promptReportFocus;
    }

    if (createAgentTypes !== undefined && createAgentTypes !== null) {
      requestBody.createAgentTypes = createAgentTypes;
    }

    if (podcast !== undefined && podcast !== null) {
      requestBody.podcast = podcast;
    }

    requestBody.isUpdate = false;
    requestBody.reportId = null;
    requestBody.privateType = null;

    return new Promise<any>((resolve, reject) => {
      axios
        .post(baseBriefingAPI + '/briefingResource/saveBriefingResourceWithBody', requestBody, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          console.error('Error in API call:', err);
          reject(err);
        });
    });
  }

  public callAPIGetPodcastByRequestId(requestId: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/get-podcast-by-request-id?requestId=' + requestId)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public countScrapeAgentData(userKey: string, bpId: string, startDate: string, endDate: string, pageWeb: string) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(
          baseBriefingAPI +
            '/briefingPage/countScrapeAgentData?userKey=' +
            userKey +
            '&bpId=' +
            bpId +
            '&startDate=' +
            startDate +
            '&endDate=' +
            endDate +
            '&pageWeb=' +
            pageWeb
        )
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
  public countAllBriefingDataByType(
    userKey: string,
    bpId: string,
    bpIds: string[],
    startDate: string,
    endDate: string,
    userKeyCheckBookMark: string,
    documentType: string[],
    mediaType: string[],
    briefingType: string[],
    language: string[],
    contentType: string[],
    keywords: string,
    collectedQualities: number[]
  ) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseBriefingAPI + '/briefingPage/countAllBriefingDataByType', {
          params: {
            userKey,
            bpId,
            bpIds,
            startDate,
            endDate,
            userKeyCheckBookMark,
            documentType,
            mediaType,
            briefingType,
            language,
            contentType,
            keywords,
            collectedQualities,
          },
          paramsSerializer: params => {
            const searchParams = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
              if (Array.isArray(value)) {
                value.forEach(val => searchParams.append(key, val));
              } else if (value !== undefined && value !== null) {
                searchParams.append(key, value as string);
              }
            });
            return searchParams.toString();
          },
        })
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
